// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27gzl","input":"styles_input__3xH3y"};